import { Stepper, StepperProps } from '@mantine/core';
import * as stepperStylesAPI from './styles/stepperStylesApi.css';
import { ICON_SIZE_MAP } from '../../icons-sizes';

export default function ResponsiveStepper(props: StepperProps) {
  return (
    <Stepper
      classNames={{ ...stepperStylesAPI }}
      iconSize={ICON_SIZE_MAP.medium}
      {...props}
    />
  );
}
